import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
    error: false,
    response: []
};

const deleteJobReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.DELETE_JOB_REQUESTED:
            return {
                ...state,
                loading: true,

            };

        case types.DELETE_JOB_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: false,
                response: action.payload
            };
        case types.DELETE_JOB_FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
                response: []
            };
        default:
            return state;
    }
};
export default deleteJobReducer;
